import React from 'react';
import PropTypes from 'prop-types';
import {  InteractiveExtraContent,
  InteractButtonWrapper,
  ButtonInteractive,
  LocationIconStyled,
  SendLocationIconText,
} from '../styled';




export const LocationRequestExtraContent = ({ locationText, sendType }) => {
  return (
    <InteractiveExtraContent>
      <InteractButtonWrapper>
        <ButtonInteractive sendType={sendType} className="button-last">
        <LocationIconStyled>📍</LocationIconStyled>
        <SendLocationIconText>{locationText}</SendLocationIconText>
        </ButtonInteractive>
      </InteractButtonWrapper>
    </InteractiveExtraContent>
  );
};

LocationRequestExtraContent.propTypes = {
  locationText: PropTypes.string,
  sendType: PropTypes.string,
};
